export const SAVE_ALL_APPRAISAL_TYPES = 'SAVE_ALL_APPRAISAL_TYPES'
